import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { Oval } from "react-loader-spinner"; // Import loader
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const UpdateTrashUnitsPage = () => {
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  const navigate = useNavigate();
  const [newAmount, setNewAmount] = useState(""); // State for new amount (trash units price)

  const handleUpdateTrashUnits = () => {
    setIsLoading(true); // Set loading state to true

    // Get property ID from localStorage
    const propertyid = JSON.parse(localStorage.getItem("propertyIdTrash"));
    const token = localStorage.getItem("token");

    // Create an object containing the new trash units price (feeamount)
    const requestBody = {
      feeamount: newAmount, // Make sure the correct key is used
    };

    // Send a PATCH request to update trash units price using axios
    axios
      .patch(
        `${StandardURL}/iNyumba/trashfee/updatetrashfee/${propertyid}`, // Use the correct endpoint for trash units
        requestBody,
        {
          headers: {
            "Content-Type": "application/json", // Set content type to application/json
            Authorization: `Bearer ${token}`, // Include token for authentication
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response); // Display success message
        setIsLoading(false);
        navigate(-1); // Navigate back to previous page
      })
      .catch((error) => {
        toast.error(error.response.data.response || "An error occurred."); // Display error message
        setIsLoading(false); // Set loading state to false
        console.error("Error updating trash units:", error);
      });
  };

  const handleNewAmountChange = (e) => {
    // Update the newAmount state with the value from the input field
    setNewAmount(e.target.value);
  };


  const handleBack = () => {
    navigate(-1); // Navigates back to the previous page in history
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded-xl shadow-2xl border border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center tracking-tight">
              Update Trash Units Price 🗑️ KES
            </h1>
            <p className="text-center text-gray-600 mb-8 max-w-sm mx-auto">
              Adjust the price per trash unit for accurate billing and management.
            </p>
            <hr className="my-6 border-gray-200" />

            {/* Input Field for New Amount */}
            <div className="mb-8">
              <label
                htmlFor="newAmount"
                className="block text-sm font-semibold text-gray-700 mb-2"
              >
                New Amount:
              </label>
              <input
                type="number"
                id="newAmount"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition duration-200 ease-in-out placeholder-gray-400"
                value={newAmount}
                onChange={handleNewAmountChange} // Update the newAmount state when input changes
                placeholder="Enter new price per unit"
                min="0" // Assuming price cannot be negative
              />
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4">
              <button
                onClick={handleUpdateTrashUnits}
                disabled={isLoading}
                className={`flex items-center justify-center px-8 py-3 rounded-lg shadow-lg font-bold transition duration-300 ease-in-out transform hover:-translate-y-0.5
                  ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-emerald-600 hover:bg-emerald-700 text-white"
                  }
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500`}
              >
                {isLoading ? (
                  <Oval
                    height={20}
                    width={20}
                    color="white"
                    visible={true}
                    ariaLabel="loading-indicator"
                    secondaryColor="white"
                  />
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                      <path
                        fillRule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Update Price
                  </>
                )}
              </button>

              <button
                type="button" // Important: use type="button" to prevent form submission
                onClick={handleBack}
                className="flex items-center justify-center px-8 py-3 bg-gray-500 text-white font-bold rounded-lg shadow-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Back
              </button>
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default UpdateTrashUnitsPage;
